module.exports = __webpack_public_path__ + "img/contra.ee4c565c.svg";